export const isEmptyObj = (obj) => !Object.keys(obj).length;
